import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tog-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/table/table.component.ts